import { Component, OnInit } from '@angular/core';
import {IResponse} from '../../interfaces/iresponse';
import {UtilService} from '../../services/utilService/util.service';
import {UserService} from '../../services/apiCalls/userService/user.service';

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css']
})
export class UserDashboardComponent implements OnInit {
  breadCrumb: any;

  public dashboard: any = null;
  constructor(private userService: UserService,
              private utilService: UtilService) {}

  ngOnInit() {
    this.setDashboard();
    this.breadCrumb  = {
      name: 'Dashboard',
      parent: 'Home',
      subLink: null
    };

  }
  public setDashboard() {
    this.userService.getDashboard()
      .subscribe((res: IResponse) => {
        this.dashboard = res.data;
      }, error => {
      });
  }
  public checkPrivilege(roles: Array<string>) {
    return this.utilService.checkPrivilegeNow(roles);
  }


}
